import ContainerConexao from "./components/container";
import { ProviderListMembro } from "./context/listMembrosConexoes";

export default function ConexoesPg() {

  return (
      <ProviderListMembro>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerConexao/>
        </div>
      </ProviderListMembro>
  )
}
